var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isSecureCheck)?_c('secure-page',{on:{"onLogin":function($event){_vm.isSecureCheck = true}}}):_vm._e(),(_vm.isSecureCheck)?_c('support-panel-main',{on:{"onInvalidToken":_vm.onInvalidToken}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }